<template>
	<div class="basket-form-agreement d-flex justify-center">
		<v-checkbox v-model="form.hasAccepted" hide-details dense>
			<template slot="label">
				<!-- label у v-checkbox - flex: без общей обертки текст и ссылка становятся отдельными колонками -->
				<span>
					Я прочитал и принимаю&nbsp;<router-link :to="{name:'terms'}"
							 target="_blank"
							 @click.native.stop="">Общие условия продажи</router-link>
				</span>
			</template>
		</v-checkbox>
	</div>
</template>

<script>
	export default {
		name: "basket-form-agreement",
		props: {
			form: {},
		},
		data() {
			return {}
		}
	}
</script>

<style lang="scss">
</style>